import toast from 'react-hot-toast'
import SignInLayout from 'src/layouts/signin-layout'
import FormItem from 'src/components/atoms/form-item'
import FormStepper from 'src/components/atoms/form-stepper'

import { useRouter } from 'src/hooks'
import { Trans } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { RecoverPassSchema } from './schema'
import { useTranslation } from 'react-i18next'
import { MailOutlined } from '@ant-design/icons'
import { sendVerificationToken } from 'src/services'
import { yupResolver } from '@hookform/resolvers/yup'
import { Col, Divider, Flex, Input, Typography, Form, Row, Button } from 'antd'

const CURRENT_STEP = 1
const TOTAL_STEPS = 3

type RecoverPassType = {
  email: string
}

export default function PassRecoveryForm() {
  const router = useRouter()

  const { i18n } = useTranslation()
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<RecoverPassType>({
    defaultValues: { email: '' },
    resolver: yupResolver(RecoverPassSchema),
  })

  const handleFinish = async (formValues: RecoverPassType) => {
    try {
      const response = await sendVerificationToken({
        Username: formValues.email,
      })

      if (response)
        router.push(`/password-recovery/validation/${formValues.email}`)
    } catch (err) {
      toast.error(i18n.t('error.unspecific'))
    }
  }

  return (
    <SignInLayout>
      <Form
        layout="vertical"
        wrapperCol={{ span: 24 }}
        onFinish={handleSubmit(handleFinish)}
        className="md:w-50vw w-full max-w-[610px] p-4"
      >
        <Flex align="center" justify="center" className="w-full">
          <FormStepper current={CURRENT_STEP} total={TOTAL_STEPS} />
        </Flex>
        <Divider />
        <Typography.Text
          underline
          className="mb-4 block cursor-pointer"
          onClick={() => router.push('/signin')}
        >
          ← {i18n.t('signIn.back')}
        </Typography.Text>
        <Flex vertical align="start" gap="large">
          <Flex vertical align="middle" gap="large">
            <div>
              <Typography.Title level={2} type="warning">
                {i18n.t('passwordRecovery.step1.title')}
              </Typography.Title>

              <Typography.Text>
                <Trans
                  i18n={i18n}
                  i18nKey="passwordRecovery.step1.description"
                  components={[<strong />]}
                />
              </Typography.Text>
            </div>

            <FormItem
              name="email"
              label={i18n.t('passwordRecovery.step1.email')}
              errors={errors}
              control={control}
              component={
                <Input
                  size="large"
                  prefix={<MailOutlined />}
                  aria-invalid={Boolean(errors.email)}
                  data-testid="pass-recovery-input-email"
                  placeholder={i18n.t(
                    'passwordRecovery.step1.emailPlaceholder'
                  )}
                />
              }
            />
          </Flex>

          <Row className="w-full">
            <Col span={24}>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
                disabled={isSubmitting}
                className="w-full font-bold"
                data-testid="pass-recovery-submit-btn"
              >
                {i18n.t('passwordRecovery.step1.submit')}
              </Button>
            </Col>
          </Row>
        </Flex>
      </Form>
    </SignInLayout>
  )
}
